import { rewardImageMap } from '@/config/reward-images'
import Step1Image from '@/assets/images/client-deals/steps/1.webp'
import Step2Image from '@/assets/images/client-deals/steps/2.webp'
import Step3Image from '@/assets/images/client-deals/steps/3.webp'
import Step4Image from '@/assets/images/client-deals/steps/4.webp'
import Step5Image from '@/assets/images/client-deals/steps/5.webp'
import Step6Image from '@/assets/images/client-deals/steps/6.webp'
import Step7Image from '@/assets/images/client-deals/steps/7.webp'
import Step8Image from '@/assets/images/client-deals/steps/8.webp'
import Step9Image from '@/assets/images/client-deals/steps/9.webp'
import Step10Image from '@/assets/images/client-deals/steps/10.webp'
import { allSpecialCurrenciesConfig } from '@/config/special-currencies'
import type { Step, StepReward } from '@/types/shared/pathway-event'
import { formatNumberFullTruncate } from '@/helpers/utils'

export const stepConfig = [
  { image: Step1Image, title: 'Reach Out', subtitle: 'Sliding into their inbox' },
  { image: Step2Image, title: 'First Chat', subtitle: 'Tell me your problems' },
  { image: Step3Image, title: 'Check Fit', subtitle: 'Are we a match?' },
  { image: Step4Image, title: 'The Proposal', subtitle: 'Here\'s what we can do' },
  { image: Step5Image, title: 'Objections', subtitle: 'Yeah but...' },
  { image: Step6Image, title: 'Negotiate', subtitle: 'Let\'s talk numbers' },
  { image: Step7Image, title: 'The Boss', subtitle: 'Take me to your leader' },
  { image: Step8Image, title: 'Final Terms', subtitle: 'Dotting the i\'s' },
  { image: Step9Image, title: 'Sign It', subtitle: 'Pen to paper' },
  { image: Step10Image, title: 'Deal Won!', subtitle: 'Money in the bank' },
]

export { rewardImageMap }

export const useClientDeals = () => {
  function isSpecialCurrencyId(value: string): boolean {
    return value in allSpecialCurrenciesConfig.value
  }

  function getCurrentStepConfig(index: number) {
    const maybeConfig = stepConfig[index]
    if (!maybeConfig) {
      throw new Error(`No step config found for index ${index}`)
    }
    return maybeConfig
  }

  function getVisibleRewards(step: Step) {
    const { reward } = step
    const keys = Object.keys(reward) as (keyof StepReward)[]

    const result: (Exclude<keyof StepReward, 'specialCurrencies'> | string)[] = []

    for (const key of keys) {
      const value = reward[key as keyof StepReward]

      if (key === 'specialCurrencies' && value && typeof value === 'object') {
        const specialRewards = Object.entries(value)
          .filter(([, amount]) => amount != null)
          .map(([currencyId]) => currencyId)

        result.push(...specialRewards)
      } else if (value != null) {
        result.push(key as Exclude<keyof StepReward, 'specialCurrencies'>)
      }
    }

    return result
  }

  function getRewardAmount(
    rewardType: Exclude<keyof StepReward, 'specialCurrencies'> | string,
    step: Step,
    goldenCoinValue: number,
  ) {
    if (rewardType === 'goldenCoins') {
      return formatNumberFullTruncate((step.reward[rewardType] as number) * goldenCoinValue)
    }
    if (isSpecialCurrencyId(rewardType)) {
      return formatNumberFullTruncate((step.reward.specialCurrencies as Record<string, number>)?.[rewardType] ?? 0)
    }
    return formatNumberFullTruncate(step.reward[rewardType as keyof StepReward] as number)
  }

  return {
    stepConfig,
    rewardImageMap,
    getCurrentStepConfig,
    getVisibleRewards,
    getRewardAmount,
  }
}

